export default "__VITE_ASSET__CD9ov1ve__"